'use client';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogPortal, DialogTitle } from '@pickleballinc/ui/components/ui/dialog';

interface PlayerBiographyModalProps {
	playerBio: string;
	onClose: () => void;
}

export const PlayerBiographyModal = ({ playerBio, onClose }: PlayerBiographyModalProps) => {
	const isHTML = /<\/?[a-z][\s\S]*>/i.test(playerBio || '');

	return (
		<Dialog open onOpenChange={onClose}>
			<DialogPortal>
				<DialogContent
					className="rounded-md flex flex-col !gap-0 w-full min-[300px]:!max-w-[310px] min-[400px]:!max-w-[390px] sm:!max-w-[630px] h-auto scrollbar-thin overflow-auto max-h-[500px]"
					hideClose
				>
					<DialogHeader>
						<div className="flex w-full items-center justify-between">
							<DialogTitle className="text-2xl font-medium leading-8 text-gray-900">Player Bio</DialogTitle>
							<FontAwesomeIcon icon={faTimes} size="xl" className="text-gray-500 ml-auto cursor-pointer" onClick={onClose} />
						</div>
					</DialogHeader>

					<div>
						<hr className="my-3" />
						<div className="flex flex-col gap-5 text-sm">
							{!!playerBio &&
								(isHTML ? (
									<div
										className="space-y-4 text-base font-normal not-italic leading-6 text-gray-700"
										dangerouslySetInnerHTML={{ __html: playerBio }}
									/>
								) : (
									<p className="space-y-4 text-base font-normal not-italic leading-6 text-gray-700">{playerBio}</p>
								))}
						</div>
						<div className="w-full flex items-center justify-end mt-3 text-gray-900">
							<Button type="button" size="lg" variant="outline" className="w-fit" onClick={onClose}>
								Close
							</Button>
						</div>
					</div>
				</DialogContent>
			</DialogPortal>
		</Dialog>
	);
};
